import type { CSSObject } from '../theme/themeTypes'
import { styled } from '../../utils/styled'
import { type ProgressProps, type Orientation } from './Types'
import { linearProgressClasses } from '@mui/material'

const orientationStaticStylesMap: Record<Orientation, object> = {
  horizontal: {
    height: '24px'
  },
  vertical: {
    width: '8px',
    height: '100%'
  }
}

const getDynamicOrientationStyles = ({ value, orientation }: { value: number; orientation: Orientation }): object => {
  return {
    ...(orientation === 'vertical' && {
      transform: `translateY(${value - 100}%) !important`
    })
  }
}

interface StyledProgressProps {
  $indicatorColor?: ProgressProps['indicatorColor']
  value: ProgressProps['value']
  orientation?: ProgressProps['orientation']
}

export const StyledProgress = styled('div')<StyledProgressProps>((props): CSSObject => {
  const { theme, $indicatorColor: indicatorColor, value } = props
  const orientation = (props.orientation ?? 'horizontal') as Orientation
  return {
    height: 'inherit',
    [`.${linearProgressClasses.root}`]: {
      ...orientationStaticStylesMap[orientation],
      borderRadius: theme.borderRadius.medium,
      backgroundColor: theme.tokens.background.tonal.soft.default
    },
    [`.${linearProgressClasses.bar1Determinate}`]: {
      border: 'none',
      ...orientationStaticStylesMap[orientation],
      ...getDynamicOrientationStyles({ value, orientation }),
      borderRadius: theme.borderRadius.medium,
      backgroundColor: theme.tokens.background.semantic[indicatorColor ?? 'info'].main.default
    }
  }
})
